import React, { useEffect, useState } from 'react'
import { useNavigation, useParams } from 'react-router-dom'
import {
  useGetDeviceProfileQuery,
  useUpdateDeviceProfileMutation,
} from '../../store/kopiliot-api/device-profile'
import ContentBlock from '../../components/common/component-card/ContentBlock'
import Spinner from '../../components/spinner/Spinner'
import { Tab, Tabs } from 'react-bootstrap'
import { DeviceProfileId } from '../../shared/models/id/device-profile-id'
import { useForm } from 'react-hook-form'
import { DeviceProfile } from '../../shared/models/device-profile'
import DeviceProfileForm from '../../features/device-profile/form/DeviceProfileForm'
import ButtonLoading from '../../components/button/ButtonLoading'
import { toast } from 'react-toastify'
import Divider from '../../components/common/Divider'
import AuditLogHome from '../audit-log/AuditLogHome'

// Define Request type
type RequestDeviceProfileDetails = {
  deviceProfileId: string
}

const DeviceProfileDetails = () => {
  const { deviceProfileId } =
    useParams<RequestDeviceProfileDetails>() as RequestDeviceProfileDetails
  const { data, isLoading, isFetching, error } =
    useGetDeviceProfileQuery(deviceProfileId)
  const [updateDeviceProfile, { isLoading: isUpdating }] =
    useUpdateDeviceProfileMutation()
  const [key, setKey] = useState('main')
  const deviceProfileForm = useForm<DeviceProfile>({ defaultValues: data })
  useEffect(() => {
    deviceProfileForm.reset(data)
  }, [data])
  const onSubmit = async (data: DeviceProfile) => {
    try {
      const res = await updateDeviceProfile(data).unwrap()
      deviceProfileForm.reset()
      toast.success(`Device profile ${res.name} mis à jour avec succès !`)
    } catch (error) {
      console.log(error)
    }
  }
  return (
    <>
      {(isLoading || isFetching) && <Spinner />}
      <ContentBlock>
        <ContentBlock.Header title={data?.name} />
        <ContentBlock.Body noLight={false} className={'pe-0 ps-0'}>
          <Tabs
            transition={true}
            unmountOnExit={true}
            fill={false}
            activeKey={key}
            onSelect={(k) => setKey(k ? k : 'main')}
          >
            <Tab eventKey={'main'} title={'Details'} className="p-3">
              <DeviceProfileForm
                form={deviceProfileForm}
                onSubmit={onSubmit}
                isEditing
                hideFields={['tenantID']}
              />
              <Divider />
              <ButtonLoading
                text={'Enregistrer'}
                variant={'outline-primary'}
                isLoading={deviceProfileForm.formState.isSubmitting}
                onClick={deviceProfileForm.handleSubmit(onSubmit)}
              />
            </Tab>

            <Tab
              eventKey="audit_logs"
              title="Audit Logs"
              className="p-0 pe-0 ps-0"
            >
              <AuditLogHome
                entityID={new DeviceProfileId(deviceProfileId)}
                hiddenColumns={['id', 'entityID']}
              />
            </Tab>
          </Tabs>
        </ContentBlock.Body>
      </ContentBlock>
    </>
  )
}

export default DeviceProfileDetails
